import {
  Center,
  Flex,
  Image,
  Text,
  Link,
} from "@chakra-ui/react";
import Lang from "../../Lang";


export default function CardPlans({ image, texts, link }) {
  return (
    <Center>
      <Flex
        w="full"
        maxW={"300px"}
        h={{ md: 500, lg: 500 }}
        overflow={'hidden'}
        direction={'column'}
      >
        <Center>
          <Link
            href={link}
          >
            <Image
              src={image}
              h={{ base: 150, md: 200, xl: 240 }}
              w={{ base: 150, md: 200, xl: 240 }}
            />
          </Link>
        </Center>
        <Text
          align="center"
          pt={{ base: 5, md: 7, lg: 10, xl: 10 }}
          pb={{ base: 10 }}
          fontSize={{ base: "1em", md: "1.1em", xl: "1.2em" }}
        >
          <Lang text={texts} />
        </Text>
      </Flex>
    </Center>

  );
}